import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firestore.js";
import { auth } from "../auth.js";
import { approveCoParent } from "../functions.js";
import { escapeHtml } from "../escape.js";

export async function renderPendingApprovals(container) {
  if (!auth.currentUser) return;
  const snap = await getDocs(query(
    collection(db, "invites"),
    where("kind", "==", "coParent"),
    where("childUid", "==", auth.currentUser.uid),
    where("awaitingKidApproval", "==", true),
  ));
  const pending = snap.docs.filter((d) => !d.data().usedAt);
  if (pending.length === 0) {
    container.innerHTML = "";
    return;
  }
  container.innerHTML = pending.map((d) => {
    const i = d.data();
    return `<div class="banner">
      Lūgums apstiprināt otro vecāku: ${escapeHtml(i.coParentEmail)}
      <button data-code="${d.id}">Apstiprināt</button>
    </div>`;
  }).join("");
  container.addEventListener("click", async (e) => {
    const btn = e.target.closest("button[data-code]");
    if (!btn) return;
    btn.disabled = true;
    try {
      await approveCoParent({ code: btn.dataset.code });
      btn.replaceWith(document.createTextNode(" ✓ apstiprināts"));
    } catch (err) {
      btn.disabled = false;
      alert("Kļūda: " + err.message);
    }
  });
}
